import React, { useCallback } from "react";
import { numberFormat } from "helper";
import ReportingService from "Lib/API/reporting";
import useWidgetData from "./useWidgetData";
import WidgetWrapper from "./WidgetWrapper";
import "./widgets.scss";

const fmt = (n) => numberFormat({ number: n ?? 0, decimal: 0, style: "currency" });

const bucketLabel = (dateRange, i) => {
  if (!dateRange?.from || !dateRange?.to) return `${i + 1}`;
  const from = dateRange.from instanceof Date ? dateRange.from : new Date(dateRange.from);
  const to = dateRange.to instanceof Date ? dateRange.to : new Date(dateRange.to);
  const days = (to - from) / 86400000;
  const t = new Date(from.getTime() + i * ((to - from) / 4));
  if (days <= 2) return t.toLocaleTimeString([], { hour: "numeric", hour12: true }).replace(":00", "").toLowerCase();
  if (days <= 90) return `${t.getMonth() + 1}/${t.getDate()}`;
  return t.toLocaleString("default", { month: "short" });
};

const DonationsWidget = ({ customizeMode, onRemove, dateRange }) => {
  const fetcher = useCallback((token) => ReportingService.getWidgetDonations(token, dateRange), [dateRange]);
  const { data, loading, error, retry } = useWidgetData(fetcher);

  const weeks = data?.weeks || [0, 0, 0, 0];
  const maxWeek = Math.max(...weeks, 1);

  const thisMonth = data?.thisMonth ?? 0;
  const lastMonth = data?.lastMonth ?? 0;
  const diff = thisMonth - lastMonth;
  const pct = lastMonth ? ((diff / lastMonth) * 100).toFixed(1) : null;
  const up = diff >= 0;

  return (
    <WidgetWrapper
      title="All Donations"
      loading={loading}
      error={error}
      onRetry={retry}
      customizeMode={customizeMode}
      onRemove={onRemove}
    >
      <div className="stat-widget">
        <div className="stat-widget__value">{fmt(thisMonth)}</div>
        <div className="stat-widget__sub">{data?.count ?? 0} donations this period</div>
        {pct !== null && (
          <div className={`stat-widget__trend stat-widget__trend--${up ? "up" : "down"}`}>
            {up ? "↑" : "↓"} {Math.abs(pct)}% vs prior period
          </div>
        )}
        <div className="bar-chart">
          {weeks.map((w, i) => {
            const barH = Math.max(Math.round((w / maxWeek) * 44), 4);
            return (
              <div key={i} className="bar-chart__col">
                <div className="bar-chart__bar" style={{ height: barH }} />
                <div className="bar-chart__lbl">{bucketLabel(dateRange, i)}</div>
              </div>
            );
          })}
        </div>
      </div>
    </WidgetWrapper>
  );
};

export default DonationsWidget;
